import React from 'react'
import { GrClose } from 'react-icons/gr'

const AddTranslationsBlogCategory = ({ isModalOpen }: any) => {
    return (
        <div>
            <div className="relative">
                <GrClose className='absolute right-2 top-2 cursor-pointer' onClick={() => isModalOpen(false)} />
            </div>
            <h2 className="font-medium text-lg">Add Translations</h2>
            <div className="my-4">
                <form action="w-fit my-10 lg:mt-96">
                    <div className="flex flex-col space-y-3 my-4">
                        <label htmlFor="lang">Select langugae</label>
                        <select className='form-select inputs md:w-96'>
                            <option value="null">----</option>
                            <option value="lang1">English</option>
                            <option value="lang1">French</option>
                        </select>
                    </div>

                    <div className="flex flex-col space-y-3 my-4">
                        <label htmlFor="category">Translated blog cateogry</label>
                        <input type="text" className='form-input inputs md:w-96' required placeholder='Enter a translated blog category....' />
                    </div>
                    <div className="flex space-x-2 my-4">
                        <input type="submit" className='btn btn-primary' value='Submit' />
                        <input type="button" className='btn btn-cancel' value='Cancel' onClick={() => isModalOpen(false)} />
                    </div>

                </form>
            </div>
        </div>
    )
}

export default AddTranslationsBlogCategory